import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./date-range-picker.scss";

import { getMonth, getYear } from "date-fns";
import CalenderIcon from "../../assets/view-modal/calendar-icon";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useLanguage } from '@erpsquad/common/runtime';
interface CustomDatePickerInputProps {
  value: string;
  onClick: () => void;
  placeholderText: string; // Define placeholderText prop
  width?: number; // Make width prop optional
}

const months: string[] = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const CustomDatePickerInput: React.FC<CustomDatePickerInputProps> = ({
  value,
  onClick,
  placeholderText,
  isRtl
}) => (
  
  <div className="calender-container">
    <input
      type="text"
      value={value}
      onClick={onClick}
      placeholder={placeholderText}
      className="open-selected-calender"
    />
    <div className={isRtl?"icon-box_rtl":"icon-box"}>
      <CalenderIcon />
    </div>
  </div>
);

interface CustomHeaderProps {
  date: Date;
  decreaseMonth: () => void;
  increaseMonth: () => void;
  decreaseYear: () => void;
  increaseYear: () => void;
  prevMonthButtonDisabled: boolean;
  nextMonthButtonDisabled: boolean;
  prevYearButtonDisabled: boolean;
  nextYearButtonDisabled: boolean;
}

function DateRangePicker(props: any) {
  const {
    start = null,
    end = null,
    startYear = 1980,
    onDateRangeChange,
    ...rest
  } = props;
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const {isRtl}=useLanguage()
  const onChange = (dates: any) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    onDateRangeChange(dates);
  };

  const years: any = [];
  const currentYear = getYear(new Date());
  for (let i = startYear; i <= currentYear + 10; i++) {
    years.push(i);
  }

  return (
    <Box className="DateRangePicker">
      <DatePicker
        dateFormat="dd-MM-yyyy"
        {...rest}
        customInput={
          <CustomDatePickerInput
            placeholderText="DD-MM-YYYY"
            value=""
            isRtl={isRtl}
            onClick={() => { }}
          />
        }
        startDate={startDate}
        endDate={endDate}
        onChange={onChange}
        selectsRange={true}
        isClearable={true}
        renderCustomHeader={({
          date,
          decreaseMonth,
          increaseMonth,
          decreaseYear,
          increaseYear,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
          prevYearButtonDisabled,
          nextYearButtonDisabled,
        }: CustomHeaderProps) => (
          <div className="date-picker-container">
            <div className="d-flex">
              <button
                onClick={decreaseMonth}
                disabled={prevMonthButtonDisabled}
                className="btn-transparent"
                type="button"
              >
                <KeyboardArrowLeft />
              </button>
              <div className="month-view">{months[getMonth(date)]}</div>
              <button
                onClick={increaseMonth}
                disabled={nextMonthButtonDisabled}
                className="btn-transparent"
                type="button"
              >
                <KeyboardArrowRight />
              </button>
            </div>
            <div className="d-flex">
              <button
                onClick={decreaseYear}
                disabled={prevYearButtonDisabled}
                className="btn-transparent"
                type="button"
              >
                <KeyboardArrowLeft />
              </button>
              <select
                className="select-year"
                value={getYear(date)}
                onChange={(e) => {
                  decreaseYear();
                  setStartDate(new Date(+e.target.value, getMonth(date)));
                }}
              >
                {years.map((year: any) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
              <button
                onClick={increaseYear}
                disabled={nextYearButtonDisabled}
                className="btn-transparent"
                type="button"
              >
                <KeyboardArrowRight />
              </button>
            </div>
          </div>
        )}
      />
    </Box>
  );
}

export { DateRangePicker };
export default DateRangePicker;
